module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('p', [_vm._v(_vm._s(_vm.decorated.commodity_and_location))]), _vm._v(" "), _c('p', {
    staticClass: "rate"
  }, [_c('span', [_vm._v("Rate:")]), _vm._v(" " + _vm._s(_vm.decorated.rate))]), _vm._v(" "), _c('ul', {
    staticClass: "details"
  }, [_c('li', [_c('span', [_vm._v("Loading Date:")]), _vm._v(" " + _vm._s(_vm.decorated.loading_date))]), _vm._v(" "), _c('li', [_c('span', [_vm._v("Loading Time:")]), _vm._v(" " + _vm._s(_vm.decorated.loading_time))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "btn-toolbar"
  }, [_c('a', {
    staticClass: "btn btn-info",
    attrs: {
      "data-toggle": "modal",
      "data-target": ".modal-load-request"
    },
    on: {
      "click": _vm.setLoadRequest
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-map-marker"
  })]), _vm._v(" "), _c('ladda-button', {
    ref: "decline",
    attrs: {
      "type": "danger",
      "disabled": !_vm.canEditLoadRequests,
      "on-click": _vm.handleDeclineRequest
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-times"
  })]), _vm._v(" "), _c('ladda-button', {
    ref: "accept",
    attrs: {
      "type": "success",
      "disabled": !_vm.canEditLoadRequests,
      "on-click": _vm.handleAcceptRequest
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check"
  })])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-9489f830"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loads/LoadRequestItem.vue
// module id = 1064
// module chunks = 0